import { Label } from "@fluentui/react/lib/Label";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";
import { TooltipDelay, TooltipHost, TooltipOverflowMode } from "@fluentui/react/lib/Tooltip";

import { isNotNullOrWhiteSpace } from "Utils/String";
import { Translator } from "Utils/Translator";
import { generateUniqueId } from "Utils/UniqueId";
import { WithTheme } from "../Theme/WithTheme";
import { WithTranslator } from "../Translator";
import { IKeyValueGridProps } from "./IKeyValueGridProps";
import { useKeyValueGridStyles } from "./UseKeyValueGridStyles";

export const KeyValueGrid = WithTheme(
  WithTranslator((props: IKeyValueGridProps): JSX.Element => {
    const {
      styleSet,
      header,
      items,
      translator,
      theme: { spacing }
    } = props;
    const styles = useKeyValueGridStyles(styleSet);

    return (
      <Stack className={styles.root} verticalAlign="start">
        <Stack disableShrink verticalAlign="center" className={styles.headerWrap}>
          {isNotNullOrWhiteSpace(header)
            ? (
              <Stack.Item>
                <TooltipHost content={header} overflowMode={TooltipOverflowMode.Parent}>
                  <Text variant="mediumPlus" className={styles.header}>
                    {header}
                  </Text>
                </TooltipHost>
              </Stack.Item>
            )
            : (
              <Stack.Item>&nbsp;</Stack.Item>
            )}
        </Stack>
        <Stack grow className={styles.content} tokens={{ childrenGap: spacing.s2 }}>
          {items.map((item, index) => {
            const id = generateUniqueId(true);
            return (
              <Stack
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                className={index % 2 !== 0 ? styles.row : styles.rowAlt}
                key={item.key}
              >
                <Stack.Item
                  className={`${styles.label} ${item.isRequired && item.isEmpty === true ? styles.labelRequired : ``}`}
                  disableShrink
                >
                  <TooltipHost
                    className={styles.tooltip}
                    content={getToolTipContent(item.key, item.isRequired, translator)}
                    overflowMode={TooltipOverflowMode.Parent}
                  >
                    <Label htmlFor={id} required={item.isRequired}>
                      {item.key}
                    </Label>
                  </TooltipHost>
                </Stack.Item>
                <Stack.Item className={styles.value} grow>
                  <TooltipHost
                    className={styles.tooltip}
                    content={item.value}
                    overflowMode={TooltipOverflowMode.Parent}
                    closeDelay={2000}

                  >
                    <Text>{item.value}</Text>
                  </TooltipHost>
                </Stack.Item>
              </Stack>
            );
          })}
        </Stack>
      </Stack>
    );
  })
);

function getToolTipContent(text: string, isRequired: boolean, translator: Translator) {
  if (!isRequired) {
    return text;
  }

  return `${text} (${translator.get(`generic.required`, `Required`)})`;
}
